import { routing } from "@/i18n/routing"

export const ensureProtocol = (url: string) => {
  if (!url) return url
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("tel:") || url.startsWith("mailto:")) {
    return url
  }
  return `https://${url}`
}

export const isExternalLink = (url: string | undefined | null): boolean => {
  if (!url) return false
  return url.startsWith("http://") || url.startsWith("https://") || url.startsWith("http:/") || url.startsWith("https:/") || url.startsWith("tel:") || url.startsWith("mailto:")
}

export const normalizeUrl = (url: string | undefined | null): string => {
  if (!url) return url || ''
  if (url.startsWith("https:/") && !url.startsWith("https://")) {
    return url.replace("https:/", "https://")
  }
  if (url.startsWith("http:/") && !url.startsWith("http://")) {
    return url.replace("http:/", "http://")
  }
  return url
}

export const formatMenuUrl = (url: string | undefined | null, locale: string): string => {
  // Theo chiến lược next-intl `localePrefix: "as-needed"`: locale mặc định (vi)
  // KHÔNG có prefix trên URL, các locale khác (en/cs) mới thêm `/{locale}`.
  const localePrefix = locale === routing.defaultLocale ? "" : `/${locale}`

  if (!url) return localePrefix || "/"

  const normalizedUrl = normalizeUrl(url)

  if (isExternalLink(normalizedUrl)) {
    return normalizedUrl
  }

  const cleanUrl = normalizedUrl.startsWith('/') ? normalizedUrl : `/${normalizedUrl}`
  return `${localePrefix}${cleanUrl}`
}
